/**
 * admin 里跨页跳转的地址。
 *
 * 单独一份的理由只有一个：**两头得对得上**。产品详情页拼 `?supplier=xxx` 跳过去，
 * 导入记录页读 `?supplier=` 初始化筛选 —— 参数名各写各的话，点过去是一张没筛过的
 * 全量列表，页面不报错、也不空，业务员只会以为「这家就是导了这么多批」。
 */

/** 某家供应商的导入记录（「货不记批次」之后，查一件货是哪批导的就靠这一跳） */
export const SUPPLIER_QUERY_KEY = 'supplier';

export function supplierMigrationsPath(supplierName: string): string {
  return `/crm/migration?${SUPPLIER_QUERY_KEY}=${encodeURIComponent(supplierName)}`;
}
